import { render, staticRenderFns } from "./WfConsumerRecordModal.Style#Drawer.vue?vue&type=template&id=0122b8e8&scoped=true&"
import script from "./WfConsumerRecordModal.Style#Drawer.vue?vue&type=script&lang=js&"
export * from "./WfConsumerRecordModal.Style#Drawer.vue?vue&type=script&lang=js&"
import style0 from "./WfConsumerRecordModal.Style#Drawer.vue?vue&type=style&index=0&id=0122b8e8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0122b8e8",
  null
  
)

export default component.exports